/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {ChartDataset} from 'chart.js';
import {PeriodInfoModel} from '../models/period-info.model';
import periodsInfoChartConfiguration from '../configuration/periods-info-chart-configuration';
import {PeriodsTypeEnum} from '../../periods-table/models/periods-type.enum';

export class PeriodsInfoChartDatasetMapper {
    constructor() {
    }

    static fromPeriodsInfoModelToChartDataset(period: PeriodInfoModel, startTimestamp: number, endTimestamp: number): ChartDataset {
        const periodColor = periodsInfoChartConfiguration.periodColors.get(<PeriodsTypeEnum>period?.type?.code);

        const chartDataset: ChartDataset = {
            label: period?.type?.name ? `${period?.type?.name}` : undefined,
            data: [
                {
                    x: startTimestamp,
                    y: period?.totalAmount
                },
                {
                    x: endTimestamp,
                    y: period?.totalAmount
                }
            ],
            fill: true,
            backgroundColor: periodColor,
            borderColor: periodColor,
            borderWidth: periodsInfoChartConfiguration.barBorderWith,
        };
        return chartDataset;
    }
}
